<div class="modal">
    <div class="modal-content">
        <div class="modal-header">
            <h2># {{ data?.channel?.name || 'Channel' }}</h2>
            <h3 class="close" (click)="closeModal()">&times;</h3>
        </div>
        <div class="modal-containers margin-bottom">
            <div class="modal-edit-header">
                <h3>Channel-Name</h3>
                <a (click)="startEditingName()" *ngIf="!isEditingName">Edit</a>
                <a (click)="saveChanges('name')" *ngIf="isEditingName">Speichern</a>
            </div>
            <div class="modal-channel">
                <div class="width-chanel">
                    <ng-container *ngIf="!isEditingName">
                        <p class="channel-name"># <span>{{ data?.channel?.name || '' }}</span></p>
                    </ng-container>
                    <ng-container *ngIf="isEditingName">
                        <div class="edit-input-container">
                            <input type="text" [(ngModel)]="editedName" placeholder="Channel Name" class="edit-input">
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
        <div class="modal-containers">
            <div class="margin-bottom">
                <div class="modal-edit-header">
                    <h3>Description</h3>
                    <a (click)="startEditingDescription()" *ngIf="!isEditingDescription">Edit</a>
                    <a (click)="saveChanges('description')" *ngIf="isEditingDescription">Speichern</a>
                </div>
                <div class="modal-channel">
                    <div class="width-chanel">
                        <ng-container *ngIf="!isEditingDescription">
                            <span>{{ data?.channel?.description || 'Keine Beschreibung' }}</span>
                        </ng-container>
                        <ng-container *ngIf="isEditingDescription">
                            <div class="edit-input-container">
                                <input type="text" [(ngModel)]="editedDescription" placeholder="Channel Beschreibung" class="edit-input description-input">
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
            <div class="modal-seperator">
                <div class="seperator"></div>
            </div>
            <div class="modal-info">
                <p>Made from</p>
                <b class="channel-creator">{{ data?.channel?.createdBy || 'Unknown' }}</b>
            </div>
        </div>
        <div class="button-container">
                <button (click)="leaveChannel()">Channel verlassen</button>
            </div>
    </div>
</div>